export const Footer = () => {
  return (
    <footer className='bg-[#2E2E2E] pt-[30px] pb-[20px] text-center'>
      <img src='./img/logo_resorttrust.svg' alt='resorttrust' className='mx-auto' />
      <small className='hp-font-sans-serif mx-auto mt-[20px] block text-[1rem] text-[#9F9F9F]'>
        COPYRIGHT © RESORTTRUST ALL RIGHTS RESERVED.
      </small>
    </footer>
  );
};
